import CustomizeAdvisor from './src/App'

import { reactToCwp } from '../../../../common/react-utils'

export default reactToCwp(CustomizeAdvisor)
